// extracted by mini-css-extract-plugin
module.exports = {"crumb-link":"crumb-link__3Jc8x","crumbLink":"crumb-link__3Jc8x"};